import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    stroke="#919499"
    viewBox="0 0 12 10"
    {...props}
  >
    <path d="m1 0 10 10m0-10L1 10" fill="none" />
  </svg>
);
const Memo = memo(SvgRemove);
export default Memo;
